import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function ManageSpecificationForm() {
  return (
    <div className="ft-form-card">
        <Form onSubmit={(e) => e.preventDefault()}>
        <h4>Add New Specification</h4>
            <hr></hr>
        <Form.Group className="mb-3" controlId="Name">
            <Form.Label>Spec name : </Form.Label>
            <Form.Control type="text" />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Spec value : </Form.Label>
            <Form.Control type="text" />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Formula :  </Form.Label>
            <Form.Control type="text" />
        </Form.Group>
        <Button variant="primary">
            Save
        </Button>
        </Form>
    </div>
  );
}

export default ManageSpecificationForm;